import type { PortalClinicItem } from '@/hooks/usePortalClinics';

/**
 * Canonical patient-portal entry into the existing public booking flow.
 * Both dashboard and Aftaler CTAs must use this path — never a second booking UI.
 */
export function portalBookingHref(
  clinic: Pick<PortalClinicItem, 'online_booking_enabled' | 'clinic_slug'> | null | undefined,
): string | null {
  if (!clinic?.online_booking_enabled) return null;
  const slug = clinic.clinic_slug?.trim();
  if (!slug) return null;
  return `/book/${slug}`;
}
